// components/dashboard/StatsCard.js
import React from "react";
import { Card } from "react-bootstrap";

const StatsCard = ({ title, value, color, bgColor, icon: Icon, iconSize, subtitle }) => {
  return (
    <Card className="stats-card shadow-sm">
      <div className="stats-content">

        {/* Icon */}
        <div
          className={iconSize ? 'stats-lg-icon' : "stats-icon"}
          style={{ background: bgColor }}
        >
          {Icon && <Icon size={iconSize || 20} color={color} />}
        </div>

        {/* Text */}
        <div>
          <h5 style={{ color }}>{value}</h5>
          <small>{title}</small>
          {subtitle && <p style={{ color }}>{subtitle}</p>}
        </div>

      </div>
    </Card>
  );
};

export default StatsCard;